import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router'
import { uniqueId } from 'utils/strings'
import Tooltip from 'components/Shared/Tooltip/Index'

import MarkedText from 'components/Shared/MarkedText/Index'
import SidebarText from '../SidebarText/Index'

const StyledLink = styled.section`
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  margin-top: -8px;
  word-break: break-word;
`

const SidebarLink = ({ text, linkTo, target, markedPart, tooltipText }) => {
  const tooltipId = uniqueId()
  const noData = !text && text !== 0
  if (noData) {
    return (
      <SidebarText text={text} />
    )
  } else {
    return (
      <StyledLink>
        <Link
          to={linkTo.pathname}
          target={target}
          data-tooltip-content={tooltipText}
          data-tooltip-id={tooltipId}
        >
          {markedPart ? <MarkedText text={text} markedPart={markedPart} /> : text}
        </Link>
        <Tooltip id={tooltipId} />
      </StyledLink>
    )
  }
}

SidebarLink.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linkTo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  target: PropTypes.string,
  markedPart: PropTypes.string,
  tooltipText: PropTypes.string,
}

export default SidebarLink
